($('a[data-toggle=modal]')).on('click', function() {
  const link = $(this);
  const target = $(link.data('target'));
  $.get(link.attr('href'), (data) => {
    target.html(data);
    target.modal('show');
  });
});

